import { render } from "./ComposeEmail.vue?vue&type=template&id=45306e46&scoped=true"
import script from "./ComposeEmail.vue?vue&type=script&lang=js"
export * from "./ComposeEmail.vue?vue&type=script&lang=js"

import "./ComposeEmail.vue?vue&type=style&index=0&id=45306e46&scoped=true&lang=css"
import "./ComposeEmail.vue?vue&type=style&index=1&id=45306e46&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45306e46"]])

export default __exports__